import React from 'react'
import '../App.css';
import work from './images/work.png'
import search from './images/search.png'
import line from './images/line.png'
import arrow from './images/arrow.png'
import dot from './images/dot.png'

import circle1 from './images/circle1.png'
import circle2 from './images/circle2.png'
import circle3 from './images/circle3.png'
import speak from './images/speak.png'

export default function Journey() {
  return (
    <div>
      <div className='journey-container'>
        <div className='journey-content'>
          <div className='container-fluid'>
          <div className='row'>
            <div className='col-lg-8'>
          <div >
          <h1>Customization Journey</h1>
          <p>No two businesses run the same way. That’s why MDQ’s Production Management System is fully customizable — built around your workflows, teams, and goals. From discovery to deployment, we craft a solution that works the way you do.</p>
          </div>
          <div >
          <div className='flow-container '>
            <div className='flow1 '>
              <img src={search} className='search'/>
              <li className='list1'>1.Requirement Gathering<span> We start by listening  to your goals, process, and challenges.</span></li>
              <div>
                <img src={line} className='line'/>
                <img src={dot} className='dot'/>
                
                <img src={arrow} className='arrow1'/>
              </div>
            </div>
            <div className='flow2'>
              <img src={circle1} className='circle'/>
              <li className='list2'>2.Choosing Right Modules <span>You choose the modules that match your workflow.</span></li>
              <div>
                
                <img src={line} className='line'/>
                <img src={dot} className='dot'/>
                
                <img src={arrow} className='arrow1'/>
              </div>
            </div>
            <div className='flow3'>
              <img src={circle2} className='circle'/>
              <li className='list3'>3. System Customization<span> We set up your system with defined roles, departments, machines, and workflows.</span></li>
              <div>
                
                <img src={line} className='line'/>
                <img src={dot} className='dot'/>
                
                <img src={arrow} className='arrow1'/>
              </div>
            </div>
            <div className='flow4'>
              <img src={circle3} className='circle'/>
              <li className='list4'>4.Train & Launch <span> Our team guides yours, ensuring smooth training before moving to a full system launch.</span></li>
              <div>
                
                <img src={line} className='line'/>
                <img src={dot} className='dot'/>
                
                <img src={arrow} className='arrow1'/>
              </div>
            </div>
            <div className='flow5'>
              <img src={speak} className='speak'/>
              <li className='list5'>5.Ongoing Support<span> Our team stands ready to support you as your business expands.</span></li>
                
              <div>
                <img src={line} className='line'/>
                <img src={dot} className='dot'/>
                
              </div>
            </div>
          </div>
          </div>
        </div>
        <div className='col-lg-4'>
           <div className='journey-image'>
          <img src={work}/>
        </div>
        </div>
        </div>
        </div>
        </div>
       
        
      </div>
    </div>
  )
}
